"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOONPAY_ENDPOINTS = exports.MOONPAY_API_BASE = void 0;
exports.MOONPAY_API_BASE = "https://api.moonpay.com";
exports.MOONPAY_ENDPOINTS = {
    CURRENCIES: "/v3/currencies",
    COUNTRIES: "/v3/countries"
};
//# sourceMappingURL=constants.js.map